import React from 'react';

import { Stack } from '@good/ui/core';

import { BookingsTableView } from './bookings-table/bookings-table-view';
import { BookingsRosterView } from './bookings-roster-view/bookings-roster-view';
import { useSearchParam } from 'utilities/react-hooks/use-search-param';
import { BookingsViewProvider } from './books-view-context/bookings-view-context';
import { BookingsViewToolbar } from './booking-view-toolbar/bookings-view-toolbar';
import { BookingsViewType } from './booking-view-toolbar/types';

type BookingsViewSwitchProps = {
  view: BookingsViewType;
};

export const BookingsViewSwitch = ({ view }: BookingsViewSwitchProps) => {
  switch (view) {
    case 'list':
      return <BookingsTableView />;
    case 'calendar':
      return <BookingsRosterView />;
    default:
      return <BookingsTableView />;
  }
};

export const BookingsViewVersion2 = () => {
  const [view, setView] = useSearchParam<BookingsViewType>('view', 'list');

  return (
    <BookingsViewProvider view={view} onChangeView={setView}>
      <Stack gap={0}>
        <BookingsViewToolbar view={view} onChangeView={setView} />
        <BookingsViewSwitch view={view} />
      </Stack>
    </BookingsViewProvider>
  );
};
